export default __webpack_public_path__ + "static/media/DownloadeIcon.640278bb.svg";